import React from 'react';
import { motion } from 'framer-motion';
export const Mechanism = () => {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-150">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-amber/5 rounded-full blur-3xl -z-10" data-id="element-151" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-amber/20 rounded-3xl p-8 md:p-12 shadow-premium relative overflow-hidden" data-id="element-153">
          <div className="absolute top-0 left-0 w-2 h-full bg-amber" data-id="element-154" />

          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-forest" data-id="element-155">
            Presentamos el Metabolic Flush
          </h2>

          <div className="space-y-6 text-lg text-charcoal-light leading-relaxed" data-id="element-156">
            <p className="font-medium text-xl text-charcoal" data-id="element-157">
              Un método de intervención rápida diseñado para enviar señales de
              seguridad a tu sistema nervioso.
            </p>
            <p data-id="element-158">
              A través de una combinación específica de fitonutrientes y hábitos
              de recuperación, le decimos a tu cuerpo que es seguro soltar el
              exceso de líquido y las toxinas. En 72 horas, reiniciamos tu
              respuesta al cortisol para que tu metabolismo vuelva a funcionar a
              tu favor y no en tu contra.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};